import gql from 'graphql-tag'

export default gql`
query ($location: String!, $startDate: Date!, $endDate: Date, $include: [String], $unitGroup: String){
	cashAssist {
		getWeatherInfo(
			location: $location,
			startDate: $startDate,
			endDate: $endDate,
			include: $include,
			unitGroup: $unitGroup
		)
	}
}
`
